export default "__VITE_ASSET__DiXKWEAR__"